import React, { useEffect, useState } from "react";
import { Loader } from "../../components/loader";
import Pagination from "../../components/pagination/paginationView";
import { fetchStoryList, deleteAdminStory } from "../../action/banner";
import trashIcon from "../../assets/images/trash-03.svg";
import editIcon from "../../assets/images/maskIcon.svg";
import plusWhite from "../../assets/images/plus-white.svg";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Modal } from "react-bootstrap";
import showNotification from "../../components/notification/showNotification";
import { Link, useNavigate } from "react-router-dom";
const AdminStoryList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [list, setList] = useState([]);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [story_id, setstory_Id] = useState("");
  const navigate = useNavigate();

  const getStoryList = async () => {
    setIsLoading(true);
    const response = await fetchStoryList(currentPage, paginationValue);
    if (response.status) {
      setIsLoading(false);
      setList(response?.data?.list);
      setTotalRecords(response?.data?.count);
    }
  };
  const deleteStory = async () => {
    const response = await deleteAdminStory(story_id);
    if (response.status) {
      showNotification("Story", "Story deleted Successfully!", "success");
      getStoryList();
      setShowDeleteModel(false);
    } else {
      showNotification("Story", response?.message, "danger");
    }
  };
  useEffect(() => {
    getStoryList();
  }, [currentPage, paginationValue]);
  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              {" "}
              <Breadcrumb paths={[{ name: "Admin story" }]} />
            </div>
          </div>
          <Link
            to={"/admin/create-admin-story"}
            className="btn btn-info addbbtn">
            Create New
            <img
              src={plusWhite}
              alt=""
              className="payout_down"
            />
          </Link>
        </div>
      </div>
      <table className="payout_table upi-mandate_table">
        <thead>
          <tr className="tableHead">
            <th className="thHeader">
              <div className="payoutHead">Story</div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">Caption</div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">View</div>
            </th>

            <th className="thHeader">
              <div className="payoutHead">Action</div>
            </th>
          </tr>
        </thead>

        {isLoading ? (
          <tr>
            <td colSpan="10">
              <Loader />
            </td>
          </tr>
        ) : (
          <>
            {list?.length > 0 ? (
              list?.map((item) => {
                return (
                  <tr key={item?._id}>
                    <td>
                      {item.assets.type == 1 && (
                        <video width="200">
                          <source
                            src={
                              process.env.REACT_APP_S3_URL +
                              "/" +
                              item.assets.url
                            }
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      )}
                      {item.assets.type == 2 && (
                        <div className="bannerImageList">
                          <img
                            style={{ width: "200px" }}
                            className="banner_img"
                            src={
                              process.env.REACT_APP_S3_URL +
                              "/" +
                              item.assets.url
                            }
                            alt="banner"
                          />
                        </div>
                      )}
                      {item.assets.type == 0 && item.assets.url}
                    </td>
                    <td>{item?.title}</td>
                    <td>{item?.viewCount}</td>

                    <td>
                      <div className="flex_btn-box justify-content-lg-start gap-2 mt-0">
                        <div className="flex_btn">
                          <img
                            src={editIcon}
                            alt="view"
                            className="eye_icon"
                            onClick={() => {
                              navigate(`/admin/admin-story-detail/${item._id}`);
                            }}
                          />
                        </div>
                        <div
                          className="flex_btn"
                          onClick={() => {
                            setShowDeleteModel(true);
                            setstory_Id(item._id);
                          }}>
                          <img
                            src={trashIcon}
                            alt="trashIcon"
                            className="i_button"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <>
                <tr>
                  <td
                    colspan="11"
                    className="text_center">
                    No data available
                  </td>
                </tr>
              </>
            )}
          </>
        )}
      </table>
      <Pagination
        currentPage={currentPage}
        totalCount={totalRecords}
        pageSize={paginationValue}
        onPageChange={(page) => setCurrentPage(page)}
        changePageSize={(page) => {
          setPaginationValue(page);
          setCurrentPage(1);
        }}
      />
      <Modal
        show={showDeleteModel}
        onHide={() => {
          setShowDeleteModel(false);
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this story ?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-dark"
            variant="secondary"
            onClick={() => {
              setShowDeleteModel(false);
            }}>
            No
          </button>
          <button
            className="btn btn-success"
            variant="primary"
            onClick={() => {
              deleteStory();
            }}
            disabled={!showDeleteModel}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminStoryList;
